import React from "react"
import {Container, Row, Col} from "reactstrap"
import TileContainer from "../containers/TitleContainer"
import TeaRoomCarousel from "./TeaRoomCarousel"
import CafeFoodCarousel from "./CafeFoodCarousel"
const Gallery = () => {
return(

    <Container fluid>
            <TileContainer title={"Gallery"}/>
            <Row className="row-m-20">
            <Col  className="remove-padding" md={{size: 8, offset: 2}}>
                <div className="textContainer">
                    Please enjoy our gallery, with photos from the tearoom, cafe spaces and freshly prepared food.
            </div>
            </Col>
            </Row>
            <Row className="row-m-20">
            <Col  className="remove-padding" md={{size: 8, offset: 2}}>
                <div className="textContainer">
            <TeaRoomCarousel/>
            </div>
            </Col>
            </Row>
            <Row className="row-m-20">
            <Col  className="remove-padding" md={{size: 8, offset: 2}}>
                <div className="textContainer">
                    A wider look at White Hart moments from our cafe and food gallery.
            </div>
            </Col>
            </Row>
            <Row className="row-m-20">
            <Col  className="remove-padding" md={{size: 8, offset: 2}}>
                <div className="textContainer">
            <CafeFoodCarousel/>
            </div>
            </Col>
            </Row>
    </Container>
)
}

export default Gallery